// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"7eb73272","141":"7eb73272","217":"78fca2a3","300":"81dedb15","563":"e7fedc7e","802":"e447f617"}[chunkId] + ".chunk.css";
};